import Reveal from '../components/Reveal';

export default function DailyChallenge() {
  return (
    <div className="daily-bg" id="daily">
      <div className="daily-inner">
        <Reveal>
          <div>
            <p className="section-label">Every Day, a New Challenge</p>
            <h2 className="section-title">Daily Challenge</h2>
            <div className="daily-badges">
              <span className="badge badge-easy">🌿 Easy</span>
              <span className="badge badge-medium">⚡ Medium</span>
              <span className="badge badge-hard">🔥 Hard</span>
            </div>
            <p className="daily-desc">
              A brand-new puzzle drops every day at midnight. Harder than the regular levels,
              richer in rewards. Maintain your daily streak and watch your bonus coins multiply.
            </p>
            <div className="daily-reward">
              <img src="/assets/spin/icon-coin.svg" alt="coin" style={{ width: 24, height: 24 }} />
              Bonus coins for daily completion
            </div>
          </div>
        </Reveal>
        <Reveal delay={150}>
          <div className="daily-mascot">
            <img src="/assets/mascot/mascot-sparkle.svg" alt="Sparkle mascot" />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
